import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

function SessionDetailPage() {
  const { id } = useParams();
  const [session, setSession] = useState({ config: {}, data: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSessionData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${API_URL}/session/${id}`);
        setSession(response.data || { config: {}, data: [] });
        setError(null);
      } catch (err) {
        setError('Failed to fetch session details.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchSessionData();
  }, [id]);

  const renderJson = (data) => {
    try {
      const parsed = JSON.parse(data);
      return JSON.stringify(parsed, null, 2);
    } catch {
      return data;
    }
  };

  return (
    <div>
      <div className="mb-4">
        <Link to="/" className="text-indigo-600 hover:text-indigo-900">
          &larr; Back to Dashboard
        </Link>
      </div>

      <h2 className="text-2xl font-bold text-gray-800 mb-4">
        Session Details: <span className="font-mono text-xl">{id}</span>
      </h2>

      {loading && <p>Loading details...</p>}
      {error && <p className="text-red-500">{error}</p>}

      {!loading && !error && (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="bg-white p-6 rounded-lg shadow">
            <h3 className="text-lg font-semibold text-gray-700 mb-3">Configuration</h3>
            <pre className="bg-gray-50 p-4 rounded overflow-auto text-sm">
              {JSON.stringify(session.config, null, 2)}
            </pre>
          </div>
          <div className="bg-white p-6 rounded-lg shadow">
            <h3 className="text-lg font-semibold text-gray-700 mb-3">Buffered Data</h3>
            {session.data.length > 0 ? (
              session.data.map((item, index) => (
                <pre key={index} className="bg-gray-50 p-4 rounded overflow-auto text-sm mb-4">
                  {renderJson(item)}
                </pre>
              ))
            ) : (
              <p className="text-gray-500">No buffered data for this session.</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default SessionDetailPage;
